<template>
    <div class="mt-5">
        <div class="d-flex section-header align-items-center text-white row py-2">
            <router-link
                :to="list"
                class="btn btn-primary rounded-pill"
            >
                <i class="fa fa-chevron-left ml-2" />
            </router-link>

            <div class="divider-v mx-3 bg-white " />
            <span class="envelope-title">
                <span v-html="sectionName" />
                <router-link
                    v-if="formData.id && !creationMode"
                    :to="list"
                    class="btn btn-primary rounded-pill pl-4 pr-4 ml-3"
                    @click.prevent="creationMode = !creationMode"
                >
                    <i class="fa mr-2 text-white" :class="[isLoading ? 'fa-circle-notch fa-spin' : 'fa-pencil']" />
                    Edit
                </router-link>
            </span>
        </div>

        <section class="row section justify-content-center company-registration">
            <div class="col-md-12">
                <contracts-form
                    form-class="card"
                    :record-data="formData"
                    :is-fetching="isFetching"
                    :creation-mode="creationMode"
                    @cancel="onCancel"
                    @saved="onSaved"
                />
            </div>
        </section>
    </div>
</template>


<script>
import { mapState } from "vuex"
import ContractsForm from "./form.vue"

export default {
    name: "ContractsSection",
    components: {
        ContractsForm
    },
    props: {
        isEditing: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            formData: {},
            isLoading: false,
            isFetching: false,
            creationMode: false,
            list: {
                name: "browse",
                params: {
                    resource: "envelopes"
                }
            },
            endpoint: "/filesystem"
        }
    },
    computed: {
        ...mapState({
            user: state => state.User.data
        }),
        sectionName() {
            return "Upload a Document and Add Envelope Participants"
        }
    },
    watch: {
        "$route.params.id": {
            handler(id) {
                if (id) {
                    this.getRecord()
                } else {
                    this.creationMode = true
                }
            },
            immediate: true
        }
    },
    methods: {
        onSaved() {
            this.$notify({
                title: "Envelope Created",
                text: "The envelope has been sent",
                type: "success"
            });
            this.$router.push({
                name: "browse",
                params: {
                    resource: "envelopes"
                }
            })
        },

        getRecord() {
            this.isFetching = true
            axios({
                url: `${this.endpoint}/${this.$route.params.id}`
            }).then(({ data }) => {
                if (data) {
                    this.formData = data
                    this.isFetching = false
                }
            })
        }
    }
};
</script>


<style lang="scss" scoped>
    .company-registration{
        .section-title {
            font-size: 24px
        }

        .title {
            font-size: 16px
        }
    }

    .section-header {
        background: var(--base-color);
        .envelope-title {
            color: white;
        }
    }
</style>

<style lang="scss">
    .company-registration{
        .wizard-icon {
            font-style: normal;
            // font-family: sans-serif;
            font-size: 0.7em !important;
        }

        .vue-form-wizard.md .wizard-icon-circle {
            top: -30px !important;
            height: 40px;
            width: 40px;
        }

        .vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle {
            position: relative;
            top: 40px;
            height: 2px;
            padding: 0 20px;
        }
    }
</style>
